import React from 'react';
import PropTypes from 'prop-types';
import { Grid, IconButton } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import cn from 'classnames';
import DialogContent from '../DialogContent';
import ForgotPasswordForm from '../../FormComponents/ForgotPasswordForm';

import useDialogStyles from '../makeStyles';
import userAuthMakeStyles from '../userAuthMakeStyles';

const ForgotPasswordDialog = ({ open, onClose }) => {
  const dialogClasses = useDialogStyles();
  const userAuthDialogClasses = userAuthMakeStyles();

  return (
    <Dialog
      onClose={onClose}
      className={cn(userAuthDialogClasses.root, userAuthDialogClasses.forgotPasswordDialogRoot)}
      classes={{ paper: dialogClasses.paper }}
      open={open}
    >
      <DialogContent>
        <Grid container spacing={5} className={userAuthDialogClasses.forgotPasswordDialogContent}>
          <Grid
            item
            xs={6}
            className={userAuthDialogClasses.forgotPasswordDialogImage}
          />
          <Grid item xs={6}>
            <div className={userAuthDialogClasses.close}>
              <IconButton aria-label="close" className={userAuthDialogClasses.closeButton} onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </div>
            <div>
              <ForgotPasswordForm />
            </div>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

ForgotPasswordDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ForgotPasswordDialog;
